<template>
    <div class="container mx-auto page p-3">
        <div>
            <router-link to="/home" class="text-blue-500 underline font-bold">Home</router-link>
        </div>
        <div class="text-gray-700 text-lg font-bold underline">Tax Address</div>
        <div class="mb-5">
            <button class="bg-green-500 text-white py-1 px-4 rounded-md mr-2"
                    @click="clickAddAddress()" data-cy="btn_page_tax_address_add">Add new tax address</button>
            <button class="bg-gray-600 text-white py-1 px-4 rounded-md"
                    @click="clickListAddressModal()" data-cy="btn_page_tax_address_list">Modal tax address list</button>
        </div>
        <TaxAddressList
                ref="tax-list"
                @onEditAddress="clickEditAddress($event)"
                @onDeleteAddress="clickDeleteAddress($event)"
                data-cy="component_page_tax_address_list"
        ></TaxAddressList>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import TaxAddressList from "../component/TaxAddressList.vue";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "TaxAddress",
    mixins: [ModalMixin],
    components: {
        TaxAddressList,
    },
    methods: {
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialTaxAddressModal();
        },
        //#endregion mixin function

        reloadAddressList: function() {
            this.$refs['tax-list'].getAddressList();
        },

        clickAddAddress: function() {
            this.addTaxAddressModal.clearModal().show();
            this.addTaxAddressModal.onAddSuccess(() => {
                this.reloadAddressList();
            });
        },
        clickEditAddress: function(address) {
            this.editTaxAddressModal
                    .clearModal()
                    .setAddress(address)
                    .show();
            this.editTaxAddressModal.onEditSuccess(() => {
                this.reloadAddressList();
            });
        },
        clickDeleteAddress: function(address) {
            this.confirmModal.clearModal()
                    .setMsg("ต้องการลบ Tax Address ?")
                    .show()
            this.confirmModal.onClickOk(() => {
                this.apiDeleteAddress(address);
            });
        },

        apiDeleteAddress: function(address) {
            this.loadingModal.show();

            BzbsAddressList.apiDeleteTaxAddress(address.rowKey).subscribe(() => {
                this.loadingModal.hide();
                this.reloadAddressList();
            }, (err) => {
                this.loadingModal.hide();
                this.errorApi(err);
            });
        },

        clickListAddressModal: function() {
            this.listTaxAddressModal.show();
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
